import {
  GET_EMAIL_SETTINGS_REQUEST,
  GET_EMAIL_SETTINGS_SUCCESS,
  GET_EMAIL_SETTINGS_FAILURE,
  CREATE_EMAIL_SETTINGS_REQUEST,
  CREATE_EMAIL_SETTINGS_SUCCESS,
  CREATE_EMAIL_SETTINGS_FAILURE,
  UPDATE_EMAIL_SETTINGS_REQUEST,
  UPDATE_EMAIL_SETTINGS_SUCCESS,
  UPDATE_EMAIL_SETTINGS_FAILURE,
  DELETE_EMAIL_SETTINGS_REQUEST,
  DELETE_EMAIL_SETTINGS_SUCCESS,
  DELETE_EMAIL_SETTINGS_FAILURE,
  SEND_TEST_EMAIL_REQUEST,
  SEND_TEST_EMAIL_SUCCESS,
  SEND_TEST_EMAIL_FAILURE,
} from '../actions/emailActions';

const initialState = {
  emailData: null,
  loading: false,
  saving: false,
  deleting: false,
  sendingTestEmail: false,
  error: null,
  validationErrors: null,
  lastMessage: null,
};

const emailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        emailData: action.payload,
        error: null,
      };

    case GET_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case CREATE_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null,
      };

    case CREATE_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        saving: false,
        emailData: action.payload.data,
        lastMessage: action.payload.message,
        error: null,
      };

    case CREATE_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error,
        validationErrors: action.validationErrors,
      };

    case UPDATE_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null,
      };

    case UPDATE_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        saving: false,
        emailData: action.payload.data,
        lastMessage: action.payload.message,
        error: null,
      };

    case UPDATE_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error,
        validationErrors: action.validationErrors,
      };

    case DELETE_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
        lastMessage: null,
      };

    case DELETE_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        deleting: false,
        emailData: null,
        lastMessage: action.payload.message,
        error: null,
      };

    case DELETE_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.error,
      };

    case SEND_TEST_EMAIL_REQUEST:
      return {
        ...state,
        sendingTestEmail: true,
        error: null,
      };

    case SEND_TEST_EMAIL_SUCCESS:
      return {
        ...state,
        sendingTestEmail: false,
        error: null,
      };

    case SEND_TEST_EMAIL_FAILURE:
      return {
        ...state,
        sendingTestEmail: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default emailReducer;
